import { render, staticRenderFns } from "./MostrarCotizacion.vue?vue&type=template&id=74bfb820&scoped=true&"
import script from "./MostrarCotizacion.vue?vue&type=script&lang=js&"
export * from "./MostrarCotizacion.vue?vue&type=script&lang=js&"
import style0 from "./MostrarCotizacion.vue?vue&type=style&index=0&id=74bfb820&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfb820",
  null
  
)

export default component.exports